export const environment = {
  production: true,
  apiUrl: 'https://api.vip.tireguru.net',
  posthogKey: 'phc_x53KzM3RjLGb5VyFJgHyKRyXCh39Qvf3Ty2pEx2HHhAD',
  posthogHost: 'https://us.i.posthog.com',
};
